module.exports = __webpack_public_path__ + "img/bg_word_cover.45913ba6.png";